import { render } from "./VSiteUpdateBanner.vue?vue&type=template&id=8dbe7c66"
import script from "./VSiteUpdateBanner.vue?vue&type=script&lang=js"
export * from "./VSiteUpdateBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__